import React from 'react'


import './title.css'

const Title = () => {

	
	return (
		<div className='front-page-container'>
			<div class='flex-container'>
				<div class='title-container'>
					<div class="text-wrapper">
						<h1 className='name-title'>Matthew Storey</h1>
						<h2 className='description-title'>Freelance Front-End Developer</h2>
					</div>
				</div>
			</div>
			<span className='scroll-down'>Scroll Down</span>
		</div>
	)
}

export default Title
